import {debugLog} from "../Utils/LogUtils";
import {useEffect} from "react";
import {apiRequest} from "../Utils/APIUtils";
import {useParams} from "react-router-dom";
import {useRef} from "react";
import {useNavigate} from "react-router-dom";



//If an ID is present, load the enrolment data from the server
// If no ID is present, save the enrolment data to the server
// And then update the URL with the new ID
export default function useLoadEnrolmentData(enrolmentState) {
    const params = useParams();
    const initialized = useRef(false); //This prevents the useEffect hook from running twice in Development
    const navigate = useNavigate();
    //It runs twice in development due to React Strict Mode
    //https://taig.medium.com/prevent-react-from-triggering-useeffect-twice-307a475714d7

    useEffect(() => {
        if (params.id) {
            //Here we are loading enrolment data from the backend
            /*enrolmentState.setApplication({
                ...enrolmentState.application,
                _enrollmentId: params.id
            });

             */
            enrolmentState.setEnrollment({
                ...enrolmentState.enrollment,
                _id: params.id
            })

            //Map the incoming values from the database to the state variables we are using in the frontend
            apiRequest(`api/enrollment/${params.id}`)
                .then(enrolment => {
                    /*enrolmentState.setApplication({
                        ...enrolment.application,
                        _enrollmentId: params.id
                    });

                     */
                    enrolmentState.setApplication(enrolment.application);
                    enrolmentState.setSubscriber(enrolment.subscriber);
                    enrolmentState.setJointSubscriber(enrolment.jointSubscriber);
                    enrolmentState.setBeneficiary(enrolment.beneficiary);
                    enrolmentState.setPlan(enrolment.plan);
                    if (enrolment.plan2) {
                        enrolmentState.setPlan2(enrolment.plan2);
                    }
                    enrolmentState.setQuote(enrolment.quote);
                    if (enrolment.quote2) {
                        enrolmentState.setQuote2(enrolment.quote2);
                    }
                    enrolmentState.setAces(enrolment.aces);
                    enrolmentState.setAgent(enrolment.agent);
                    enrolmentState.setConfiguration(enrolment.configuration);
                    enrolmentState.setCommon(enrolment.common);
                    enrolmentState.setDependant(enrolment.dependant);
                    enrolmentState.setDependant2(enrolment.dependant2);
                    enrolmentState.setDependant3(enrolment.dependant3);
                    enrolmentState.setDependant4(enrolment.dependant4);
                    enrolmentState.setDependant5(enrolment.dependant5);
                    enrolmentState.setKnowYourClient(enrolment.knowYourClient);
                    enrolmentState.setTransfer(enrolment.transfer);
                    enrolmentState.setDocusign(enrolment.docusign);
                    enrolmentState.setEnrollment({
                        ...enrolmentState.enrollment,
                        _id: enrolment._id,
                        state: enrolment.state,
                        validated: enrolment.validated
                    });
                    if (enrolment.drChecklist) {
                        enrolmentState.setDrChecklist(enrolment.drChecklist);
                    }
                })
                .catch(error => console.error('Error:', error))

        } else {
            //Here we are creating a new enrolment on the backend
            if (!enrolmentState.enrollment._id && !initialized.current) {
                initialized.current = true //Only run this once - prevent double running in development due to strict mode
                apiRequest('api/enrollment', 'POST', enrolmentState)
                    .then(response => {
                        debugLog(response); // Handle success response

                        //If we don't have an _id, replace the URL with the new one
                        //This is because we are saving for the first time
                        if (!enrolmentState._id) {
                            //window.history.replaceState("", "Enrolment", "/enrolment/" + response._id + "/Basic");
                            navigate("/enrolment/" + response._id + "/Basic");
                        }

                        //Artificially add the _id to the data object
                        // This could be done better!
                        /*enrolmentState.setApplication({
                            ...enrolmentState.application,
                            _enrollmentId: response._id
                        });

                         */
                        enrolmentState.setEnrollment({
                            ...enrolmentState.enrollment,
                            _id: response._id,
                            state: response.state
                        });

                    }).catch(error => {
                        console.error('There was a problem with your fetch operation:', error);
                    });
            }
        }
        debugLog("useLoadEnrolmentData");
    }, [params.id, enrolmentState.enrollment._id]);
}